/**
 * 模板编辑器默认画布尺寸与布局（按横竖屏区分）
 * 横屏: 1920×1080 / 竖屏: 1080×1920
 */

// 横屏默认布局 (1920×1080)
export const defaultGrid = [
	{
		name: 'weather',
		icon: 'default',
		detail: '天气组件',
		minWidth: 352,
		minHeight: 189,
		width: 352,
		height: 189,
		lockAspectRatio: true,
		x: 45,
		y: 45,
		i: 1,
	},
	{
		name: 'courses',
		icon: 'default',
		detail: '当前课程组件',
		minWidth: 352,
		minHeight: 189,
		width: 352,
		height: 189,
		lockAspectRatio: true,
		border: true,
		x: 450,
		y: 45,
		i: 2,
	},
	{
		name: 'deptInfo',
		icon: 'default',
		detail: '班级信息组件',
		minWidth: 352,
		minHeight: 189,
		width: 352,
		height: 189,
		lockAspectRatio: true,
		x: 832,
		y: 45,
		i: 3,
	},
	{
		name: 'atten',
		icon: 'default',
		detail: '考勤组件',
		minWidth: 352,
		minHeight: 189,
		width: 352,
		height: 189,
		lockAspectRatio: true,
		border: true,
		x: 1184,
		y: 45,
		i: 4,
	},
	{
		name: 'week',
		icon: 'default',
		detail: '教学周组件',
		minWidth: 352,
		minHeight: 189,
		width: 352,
		height: 189,
		lockAspectRatio: true,
		border: true,
		x: 1536,
		y: 45,
		i: 5,
	},
	{
		name: 'deptVideo',
		icon: null,
		detail: '班级视频组件',
		minWidth: 100,
		minHeight: 100,
		width: 752,
		height: 702,
		color: '#fff',
		background: '#000',
		lockAspectRatio: false,
		x: 45,
		y: 270,
		i: 6,
	},
	{
		name: 'notice',
		icon: null,
		detail: '校园公告组件',
		minWidth: 512,
		minHeight: 225,
		width: 1056,
		height: 225,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 832,
		y: 261,
		i: 7,
	},
	{
		name: 'dayCourse',
		icon: null,
		detail: '今日课程表组件',
		minWidth: 704,
		minHeight: 225,
		width: 1056,
		height: 225,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 832,
		y: 513,
		i: 8,
	},
	{
		name: 'honor',
		icon: null,
		detail: '荣誉组件',
		minWidth: 512,
		minHeight: 225,
		width: 1056,
		height: 225,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 832,
		y: 747,
		i: 9,
	},
]

// 竖屏默认布局 (1080×1920)
export const defaultPortraitGrid = [
	{
		name: 'weather',
		icon: 'default',
		detail: '天气组件',
		minWidth: 342,
		minHeight: 192,
		width: 342,
		height: 192,
		lockAspectRatio: true,
		x: 9,
		y: 32,
		i: 1,
	},
	{
		name: 'courses',
		icon: 'default',
		detail: '当前课程组件',
		minWidth: 342,
		minHeight: 192,
		width: 342,
		height: 192,
		lockAspectRatio: true,
		border: true,
		x: 369,
		y: 32,
		i: 2,
	},
	{
		name: 'deptInfo',
		icon: 'default',
		detail: '班级信息组件',
		minWidth: 342,
		minHeight: 192,
		width: 342,
		height: 192,
		lockAspectRatio: true,
		x: 729,
		y: 32,
		i: 3,
	},
	{
		name: 'atten',
		icon: 'default',
		detail: '考勤组件',
		minWidth: 342,
		minHeight: 192,
		width: 342,
		height: 192,
		lockAspectRatio: true,
		border: true,
		x: 720,
		y: 960,
		i: 4,
	},
	{
		name: 'week',
		icon: 'default',
		detail: '教学周组件',
		minWidth: 342,
		minHeight: 192,
		width: 342,
		height: 192,
		lockAspectRatio: true,
		border: true,
		x: 720,
		y: 1280,
		i: 5,
	},
	{
		name: 'deptVideo',
		icon: null,
		detail: '班级视频组件',
		minWidth: 99,
		minHeight: 112,
		width: 1062,
		height: 608,
		color: '#fff',
		background: '#000',
		lockAspectRatio: false,
		x: 9,
		y: 272,
		i: 6,
	},
	{
		name: 'notice',
		icon: null,
		detail: '校园公告组件',
		minWidth: 513,
		minHeight: 192,
		width: 675,
		height: 192,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 18,
		y: 1280,
		i: 7,
	},
	{
		name: 'dayCourse',
		icon: null,
		detail: '今日课程表组件',
		minWidth: 702,
		minHeight: 192,
		width: 1053,
		height: 192,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 15,
		y: 1575,
		i: 8,
	},
	{
		name: 'honor',
		icon: null,
		detail: '荣誉组件',
		minWidth: 513,
		minHeight: 192,
		width: 675,
		height: 192,
		color: '#000',
		lockAspectRatio: false,
		border: true,
		x: 18,
		y: 960,
		i: 9,
	},
]

export function getDevicePreset(arg1, arg2) {
  const isPortrait = typeof arg1 === 'boolean' ? arg1 : !!arg2
  return isPortrait ? { width: 1080, height: 1920 } : { width: 1920, height: 1080 }
}

export function getDefaultLayout(arg1, arg2) {
  const isPortrait = typeof arg1 === 'boolean' ? arg1 : !!arg2
  const layout = isPortrait ? defaultPortraitGrid : defaultGrid
  return JSON.parse(JSON.stringify(layout))
}

export function isDefaultPortrait() {
  return false
}
